import React from 'react';
import ReactDOM from 'react-dom';
import { GustoSiteSearch } from '@gusto/niffler';

const mountPoint = document.getElementById('site-search');

if (mountPoint) {
  const body = document.querySelector('body');
  const navBar = document.querySelector('.navbar-collapse');
  const mobileOpener = document.querySelector('.menu-icon');

  const handleResultsPanelClose = () => {
    body.classList.remove('overflow-hidden-y');
  };

  const handleResultsPanelOpen = () => {
    body.classList.add('overflow-hidden-y');
    navBar.classList.remove('in');
    mobileOpener.classList.remove('open');
  };

  ReactDOM.render(
    React.createElement(GustoSiteSearch, {
      resultsContainerId: 'site-search-results',
      onResultsPanelClose: handleResultsPanelClose,
      onResultsPanelOpen: handleResultsPanelOpen,
    }),
    mountPoint
  );
}
